/**
 * Formats a date string for display without seconds.
 * Example output: "1/6/2026, 2:48 PM"
 *
 */
export function FormattedDate({ value }: { value: string | number }) {
  const date = new Date(value);
  const formatted = date.toLocaleString(undefined, {
    dateStyle: 'short',
    timeStyle: 'short',
  });

  return <time dateTime={date.toISOString()}>{formatted}</time>;
}
